export class JobError extends Error {
  constructor (message?: string, public readonly traceId?: string) {
    super(message);
    Object.setPrototypeOf(this, JobError.prototype);
    // Error.captureStackTrace(this, this.constructor);
  }
}
